import { useEffect, useState } from 'react';
import { useAuthStore } from '@/store/auth.store';

function resolveUrl(url: string): string {
  if (url.startsWith('http')) return url;
  return `/api${url}`;
}

export function AuthenticatedImage({
  src,
  alt,
  className,
}: {
  src?: string;
  alt: string;
  className?: string;
}) {
  const [blobUrl, setBlobUrl] = useState<string | null>(null);
  const token = useAuthStore((state) => state.token);

  useEffect(() => {
    if (!src) return;

    const fetchUrl = resolveUrl(src);
    let objectUrl: string | null = null;
    let cancelled = false;

    const headers: Record<string, string> = {};
    if (token && !src.startsWith('http')) {
      headers['Authorization'] = `Bearer ${token}`;
    }

    fetch(fetchUrl, { headers })
      .then((res) => {
        if (!res.ok) throw new Error('Image load failed');
        return res.blob();
      })
      .then((blob) => {
        if (!cancelled) {
          objectUrl = URL.createObjectURL(blob);
          setBlobUrl(objectUrl);
        }
      })
      .catch(() => {
        if (!cancelled) setBlobUrl(null);
      });

    return () => {
      cancelled = true;
      if (objectUrl) URL.revokeObjectURL(objectUrl);
    };
  }, [src, token]);

  if (!blobUrl) return null;
  return <img src={blobUrl} alt={alt} className={className} />;
}
